import React, { useContext, useState, useEffect } from "react";
import { Context } from "../../components/contexts/AppContext";
import { getData, putData } from "../../lib/utils";
import { useParams } from "react-router-dom";

function HeadingSideNav() {
  const { value } = useContext(Context);
  const [appState, setAppState] = value;

  // Local state for title and subtitle
  const [title, setTitle] = useState("");
  const [subtitle, setSubtitle] = useState("");

  const { galleryId } = useParams();

  // Fetch data when component mounts or galleryId changes
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getData(`galleries/gallery/${galleryId}`);

        if (response) {
          console.log("HEADINGSIVENAV.JS call get galleries/gallery api", response);

          const obj = {
            name: response.folder?.name || "",
            id: response.folder?._id || "",
            galleries: [response.gallery] || [],
            adminId:response.folder?.adminId
          };

          setAppState((prevState) => ({
            ...prevState,
            currentFolderData: obj,
            currentGalleryData:response.gallery,
            videoArr: response.videos || [],
            currentGalleryName: response.gallery?.name || "",
            currentGalleryVideoTitle: response.gallery?.title || "",
            currentGalleryVideoSubTitle: response.gallery?.subtitle || "",
             currentFontFamilyVideoTitle: response.gallery?.fheading || "",
            currentFontFamilyVideoSubTitle: response.gallery?.fbody || "",
            currentTitleColor: response.gallery?.titleColor || "",
            currentSubTitleColor: response.gallery?.subTitleColor || "",
            currentFontLogo: response.gallery?.flogo || "",
            currentColorLogo: response.gallery?.logoColor || "",
            currentLogoFontSize: response.gallery?.logoFontSize || "",
            
          }));

          // ✅ Set Title and Subtitle in Local State
          setTitle(response.gallery?.title || "");
          setSubtitle(response.gallery?.subtitle || "");
        }
      } catch (error) {
        console.error("Error fetching gallery data:", error);
      }
    };

    fetchData(); // Call the async function
  }, [galleryId]); // Ensure effect runs when galleryId changes

  // Handle title input change
  const handleTitleChange = (e) => {
    setTitle(e.target.value);
  };

  // Handle subtitle input change
  const handleSubtitleChange = (e) => {
    setSubtitle(e.target.value);
  };

  // Handle Update button click
  const handleUpdate = async () => {
    //console.log("Updated Title:", title);
    //console.log("Updated Subtitle:", subtitle);

    try {
      const json = await putData(`galleries/update-gallery-title/`, {
        title: title,
        subtitle: subtitle,
        galleryId: galleryId,
      });

      if (json) {
        //console.log("JSON =====", json);
        
        setAppState((prevState) => ({
          ...prevState,
          currentGalleryVideoTitle: json.gallery.title,
          currentGalleryVideoSubTitle: json.gallery.subtitle,
        }));

        // ✅ Also Update Local State
        setTitle(json.gallery.title);
        setSubtitle(json.gallery.subtitle);
      }
    } catch (error) {
      console.error("Error updating gallery title:", error);
    }
  };

  return (
    <div className="p-1 w-[200px]">
      {/* Heading Section */}
      <div className="font-bold text-lg py-3 px-1">Heading</div>

      {/* Title Field */}
      <div className="mb-4">
        <label htmlFor="title" className="txt-yellow">
          Title
        </label>
        <input
          type="text"
          id="title"
          className="inp-txt"
          value={title}
          onChange={handleTitleChange}
          required
          autoFocus
        />
      </div>
<div className="flex gap-3 flex-wrap mt-3">
  {["❤️", "♡", "✦", "❦", "💍", "✨", "☬"].map((sym, i) => (
    <button
      key={sym}
      type="button"
      className={`symbol-btn ${
        sym === "❤️" ? "heart-btn" : ""
      } ${sym === "💍" ? "ring-btn" : ""} ${
        sym === "✨" ? "spark-btn" : ""
      }`}
      style={{ animationDelay: `${i * 0.2}s` }}
      onClick={() => setTitle(title + " " + sym + " ")}
    >
      <span className="relative z-10">{sym}</span>
    </button>
  ))}
</div>

      {/* Subtitle Field */}
      <div className="mb-4">
        <label htmlFor="subtitle" className="txt-yellow">
          Subtitle (Optional)
        </label>
        <input
          type="text"
          id="subtitle"
          className="inp-txt"
          value={subtitle}
          onChange={handleSubtitleChange}
        />
      </div>

      {/* Update Button */}
      <button type="button" className="btn-yellow" onClick={handleUpdate}>
        Update
      </button>
    </div>
  );
}

export default HeadingSideNav;
